// extracted by mini-css-extract-plugin
export default {"wrapper":"ExternalTooltip_wrapper__673n+"};